<template>
  <div class="video-container">
    <video
      preload="metadata"
      :poster="poster?.filename || ''"
      v-bind="{ controls, autoplay, loop, muted }"
    >
      <Scaffold v-if="Array.isArray(video)">
        <source :src="vid.filename || ''" v-for="vid in video" />
      </Scaffold>
      <source :src="video?.filename || ''" v-else />
    </video>
  </div>
</template>

<script lang="ts" setup>
import { Scaffold } from "cja-phoenix";
import { AssetStoryblok } from "~/types/bloks";

withDefaults(
  defineProps<{
    video: AssetStoryblok | AssetStoryblok[];
    poster?: AssetStoryblok;
    controls?: boolean;
    autoplay?: boolean;
    loop?: boolean;
    muted?: boolean;
  }>(),
  {
    controls: true,
  }
);
</script>

<style lang="scss" scoped>
.video-container {
  video {
    max-width: 100%;
    display: block;
  }
}
</style>
